import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Hearing as HearingIcon } from '@mui/icons-material';
import QuestionSetFormBase from '../../components/forms/QuestionSetFormBase';
import * as api from '../../api/listeningQuestionSetApi';
import { extractQuestionSetId } from '../../utils/apiHelpers';

const ListeningQuestionSetForm = () => {
  const { listeningId, questionSetId } = useParams();
  const location = useLocation();
  const { part } = location.state || { part: 'part1' };

  return (
    <QuestionSetFormBase
      parentId={listeningId}
      questionSetId={questionSetId}
      section={part}
      sectionKey="part"
      sectionOptions={['part1', 'part2', 'part3', 'part4']}
      sectionLabel="Part"
      icon={HearingIcon}
      basePath="/listenings"
      api={api}
      extractQuestionSetId={extractQuestionSetId}
    />
  );
};

export default ListeningQuestionSetForm;
